import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/QC-AI/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/QC-AI/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/QC-AI/web/src/components/icons/Logo.tsx");
;
import(/* webpackMode: "eager" */ "/Users/panxo/Development/QC-AI/web/src/components/ui/AnimatedCard.tsx");
